export const MODULE = {
  liveConsole: 'LIVE-CONSOLE',
};
